module.exports = __webpack_public_path__ + "img/Process Manage.5d500bef.svg";